import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  ErrorOutlineOutlinedIcon,
  Flex,
  Text,
} from '@shared/components';

import { useQuestionCreationTaskDetails } from '../../providers';

interface IncompleteQuestionCreationTaskModalProps {
  open: boolean;
  onClose: () => void;
}

export default function IncompleteQuestionCreationTaskModal(
  props: Readonly<IncompleteQuestionCreationTaskModalProps>,
) {
  const { open: isOpen, onClose } = props;
  const { task } = useQuestionCreationTaskDetails();
  const requirement = task.metadata?.requirement;

  const itemSetQuestionCount = task.metadata?.requirement.itemSetCondition?.map((itemSet) => {
    const questionCreationCount =
      task.metadata?.requirement.itemSetCreation?.filter(
        (creation) =>
          creation.size === itemSet.size && creation.questionCreationCount === itemSet.size,
      ).length ?? 0;
    return {
      size: itemSet.size,
      count: questionCreationCount,
      requiredCount: itemSet.needTotal,
    };
  });

  const singleQuestionCount = requirement?.questionCreationCount ?? 0;
  const requiredSingleQuestionCount = requirement?.requiredQuestionCount ?? 0;

  const shouldDisplaySingleQuestionCount = !!requiredSingleQuestionCount;

  return (
    <Dialog open={isOpen} onClose={onClose} maxWidth='xs'>
      <DialogTitle sx={(theme) => ({ textAlign: 'center', pb: theme.spacing(2) })}>
        <ErrorOutlineOutlinedIcon
          sx={(theme) => ({ color: theme.palette.error.main, fontSize: 100 })}
        />
      </DialogTitle>
      <DialogContent
        sx={(theme) => ({
          display: 'flex',
          flexDirection: 'column',
          gap: theme.spacing(2),
          alignItems: 'center',
        })}
      >
        <Text variant='h3'>ยังสร้างคำถามไม่ครบตามที่กำหนด</Text>
        <Flex sx={(theme) => ({ gap: theme.spacing(9), width: '100%', justifyContent: 'center' })}>
          {shouldDisplaySingleQuestionCount ? (
            <>
              <Text sx={{ width: '110px' }}>Single</Text>
              <Text variant='body1Semibold'>
                {singleQuestionCount} / {requiredSingleQuestionCount} ข้อ
              </Text>
            </>
          ) : null}
        </Flex>
        {itemSetQuestionCount?.map((itemSet) => {
          return (
            <Flex
              key={itemSet.size}
              sx={(theme) => ({ gap: theme.spacing(6), width: '100%', justifyContent: 'center' })}
            >
              <Text sx={{ width: '110px' }}>{`Item Set: ${itemSet.size}Q`}</Text>
              <Text variant='body1Semibold'>
                {itemSet.count} / {itemSet.requiredCount} Sets
              </Text>
            </Flex>
          );
        })}
      </DialogContent>
      <DialogActions sx={(theme) => ({ justifyContent: 'center', pt: theme.spacing(2) })}>
        <Button onClick={onClose} size='large'>
          กลับไปสร้างต่อ
        </Button>
      </DialogActions>
    </Dialog>
  );
}
